import React from 'react';
import { UpdateForm, UpdateFormProps } from 'framework/form';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import NoteForm from 'domain/sales/shared/timeline/note/form/NoteForm';
import useCrmStrategyNoteService from '../crmStrategyNoteService';

interface UpdateStrategyNoteFormProps extends Omit<UpdateFormProps, 'submitFormFunc'> {
  onCancel: () => void;
}

const UpdateStrategyNoteForm = ({ getDataFunc, onCancel, ...props }: UpdateStrategyNoteFormProps) => {
  const { getValidationSchema, update } = useCrmStrategyNoteService();

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={update}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <NoteForm isStrategy />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateStrategyNoteForm;
